<template>
  <div
    class="boss-table-2-layout"
    data-test="layout"
  >
    <div
      class="boss-table-2-item boss-table-2-item-head"
      data-test="label"
    >
      {{ label }}
      <span
        v-if="requiredLabel"
        class="label alert pega-block-fit-content"
        data-test="alert-label"
      >{{ requiredLabel }}</span>
    </div>
    <div
      class="width-100"
      :class="['boss-table-2-item', 'boss-table-2-item-body', hasChild ? 'boss-table-2-item-body-has-child' : 'display-flex' ]"
      data-test="body"
    >
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    hasChild: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
      type: String
    },
    isRequired: {
      default: false,
      type: Boolean
    },
    required: {
      default: '',
      type: String
    }
  },
  computed: {
    requiredLabel () {
      return this.required ? this.required
        : this.isRequired ? '必須' : ''
    }
  }
}
</script>
